import { makeStyles } from "@mui/styles";

const drawerWidth = 272;

export default makeStyles((theme) => ({
  menuButton: {
    marginLeft: 12,
    marginRight: 36
  },
  hide: {
    display: "none"
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap"
  },
  drawerOpen: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 40,
    [theme.breakpoints.down("sm")]: {
      width: drawerWidth
    }
  },
  sidebarLogo: {
    // ...theme.mixins.toolbar,
    backgroundColor: `${theme.palette.primary.main} !important`,
    width: drawerWidth,
    paddingTop: 32,
    position: "fixed",
    top: 0,
    zIndex: 30,
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    },
    "@media (max-width: 900px)": {
      paddingLeft: 35
    },
    "@media (max-width: 600px)": {
      paddingLeft: 0
    }
  },
  logoContent: {
    // width: "160px",
    height: "35px"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  sidebarList: {
    width: drawerWidth
  },
  mainSidebarList: {
    paddingTop: "84px !important",
    paddingBottom: "180px !important",
    height: "100vh",
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none"
    }
  },
  mobileBackButton: {
    position: "absolute",
    top: "20px",
    right: "10px",
    backgroundColor: theme.palette.background.light,
    borderRadius: "8px",
    color: theme.palette.primary.main,
    marginTop: theme.spacing(0.5),
    zIndex: 31,
    marginLeft: 18,
    [theme.breakpoints.only("sm")]: {
      marginTop: theme.spacing(0.625)
    },
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  headerIcon: {
    color: theme.palette.primary.light
  },
  footer: {
    display: "flex",
    alignItems: "center",
    position: "fixed",
    bottom: 0,
    width: drawerWidth,
    gap: 25,
    padding: 15,
    backgroundColor: `${theme.palette.primary.main} !important`,
    pointerEvents: "none"
  },
  footerlink: {
    textDecoration: "none",
    pointerEvents: "auto"
  },
  footercontainer: {
    display: "flex",
    alignItems: "center",
    gap: 10
  },
  footertextwrapper: {
    textAlign: "left",
    width: 140,
    overflow: "hidden"
  },
  initials: {
    backgroundColor: "#FFE7CC",
    color: `${theme.palette.primary.main}`,
    fontSize: 22,
    width: 40,
    height: 40,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"

  },
  name: {
    color: "white",
    marginBottom: 0,
    fontSize: 12,
    fontWeight: 500,
    marginTop: 0,
    letterSpacing: "-0.2px"
  },
  email: {
    marginBottom: 0,
    marginTop: 0,
    fontSize: 12,
    color: "white",
    letterSpacing: "-0.2px"
  },
  logout: {
    color: "#CB1A14",
    marginRight: 10,
    pointerEvents: "auto",
    "&:hover": {
      cursor: "pointer"
    }
  }
}));
